import { styled } from 'styled-components';

export const Heading = styled.h5`
  padding: var(--spacing-tiny) 0 var(--spacing-small);
`;
